import React, { useState, useEffect } from "react";
import { Loading, Modal } from "wup-module1-base";
import { Col, Row, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-regular-svg-icons";
import SzafirComponent from "../Szafir/SzafirComponent";
import { AppHelpers } from "../../Helpers/App/AppHelpers";
import { toast } from "react-toastify";

const SignApplicationModal = (data) => {
  const [isAppletActive, setIsAppletActive] = useState(false);
  const [useApplet, setIsUseApplet] = useState(false);
  function onCancel() {
    data.setIsApplicationModalOpen(false);
    setIsAppletActive(false);
  }

  function onSignByPZ() {
    let currentPath;
    currentPath = window.location.href;

    if(!!data.formUuid && !!data.clientId){
      if (currentPath.includes(`localhost:3000`)) {
        window.location.href = `http://localhost:8000/podpiszPz/${data.formUuid}/${data.clientId}`;
      } else {
        let baseUrl = currentPath?.split("/m1")[0];
        window.location.href = `${baseUrl}/podpiszPz/${data.formUuid}/${data.clientId}`;
      }
    }else{
      toast.error("Nie udało się utworzyć linku URL do podpisu zaufanego. Odśwież stronę i spróbuj ponownie.")
    }
  }

  function runSignApplet() {
    setIsAppletActive(true);
  }

  function checkToUseApplet() {
    var useAppletHelper = false;
    var isFireFox52 = false;

    var userAgent = navigator.userAgent.toLowerCase();
    var browserVersion;

    function getBrowserVersion() {
      var match = userAgent.match(/(firefox|chrome|opera|edge)\/?\s*(\d+)/i);
      if (match && match.length > 2) {
        return parseInt(match[2], 10);
      }
      return 0;
    }

    if (userAgent.indexOf("firefox") > -1) {
      browserVersion = getBrowserVersion();
      if (browserVersion >= 52) {
        isFireFox52 = true;
      }
    }

    if (
      userAgent.indexOf("opera") === -1 &&
      userAgent.indexOf("chrome") === -1 &&
      userAgent.indexOf("edge") === -1 &&
      !isFireFox52
    ) {
      useAppletHelper = true;
    }

    setIsUseApplet(useApplet);
  }

  useEffect(() => {
    checkToUseApplet();
  }, []);

  return (
    <>
      {false ? (
        <Loading className="px-1 mr-3 nav-link" size="sm" />
      ) : (
        <>
          <Modal
            show={data.isApplicationModalOpen}
            size={"lg"}
            onCancel={onCancel}
            enforceFocus={true}
            confirmButtonText="Tak"
            className={"sign-application-modal"}
          >
            {!!isAppletActive ? (
              <Card.Body>
                <SzafirComponent
                  taskList={data.taskList}
                  setIsAppletActive={setIsAppletActive}
                  type={data.documentType}
                  contractNumber={data?.contractNumber}
                ></SzafirComponent>
              </Card.Body>
            ) : (
              <Card.Body>
                <h6>Wybierz rodzaj podpisu</h6>
                <Row>
                  <Col md={4}>
                    <Card
                      tabIndex={"0"}
                      onKeyUp={AppHelpers.clickOnEnter}
                      className="main-card sign-card focusable"
                      role="button"
                      onClick={onSignByPZ}
                    >
                      <Card.Body>
                        {" "}
                        <FontAwesomeIcon
                          className="menu-icon"
                          icon={faEdit}
                        />{" "}
                      </Card.Body>
                      <Card.Footer>
                        <p>Podpis zaufany</p>
                      </Card.Footer>
                    </Card>
                  </Col>
                  <Col md={4}>
                    <Card
                      tabIndex={"0"}
                      onKeyUp={AppHelpers.clickOnEnter}
                      className="main-card sign-card focusable"
                      role="button"
                      onClick={runSignApplet}
                    >
                      <Card.Body>
                        {" "}
                        <FontAwesomeIcon
                          className="menu-icon"
                          icon={faEdit}
                        />{" "}
                      </Card.Body>
                      <Card.Footer>
                        <p>Podpis kwalifikowany</p>
                      </Card.Footer>
                    </Card>
                  </Col>
                  <Col md={4}>
                    <Card
                      tabIndex={"0"}
                      onKeyUp={AppHelpers.clickOnEnter}
                      className="main-card sign-card focusable"
                      role="button"
                      onClick={runSignApplet}
                    >
                      <Card.Body>
                        {" "}
                        <FontAwesomeIcon
                          className="menu-icon"
                          icon={faEdit}
                        />{" "}
                      </Card.Body>
                      <Card.Footer>
                        <p>Podpis osobisty</p>
                      </Card.Footer>
                    </Card>
                  </Col>
                </Row>
              </Card.Body>
            )}
          </Modal>
        </>
      )}
    </>
  );
};

export default SignApplicationModal;
